module.exports = __webpack_public_path__ + "img/2016-02.55508279.jpg";